import { render, staticRenderFns } from "./OrderFlowTypeButton.vue?vue&type=template&id=6419cb25&scoped=true&"
import script from "./OrderFlowTypeButton.vue?vue&type=script&lang=js&"
export * from "./OrderFlowTypeButton.vue?vue&type=script&lang=js&"
import style0 from "./OrderFlowTypeButton.vue?vue&type=style&index=0&id=6419cb25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6419cb25",
  null
  
)

export default component.exports